import React, {Component} from "react";
import './../../../node_modules/izitoast/dist/css/iziToast.min.css';
import {withTranslate} from "react-redux-multilingual"
import {connect} from "react-redux"
import globalMiddleware from "../../hocs/globalMiddleware"
import {withRouter} from "react-router-dom";
import Select from 'react-select';
import {withLastLocation} from 'react-router-last-location';
import {
    setHospitalDoctorsSearchData,
    clearHospitalDoctorsSearchData,
    getHospitalDoctors,
    clearHospitalDoctorsList
} from "../../store/actions/hospitalActions"

class HospitalDoctorsSearch extends Component {

    state = {
        branch: null,
        specialty: null,
    };

    componentWillReceiveProps(nextProps, nextContext) {
        if (nextProps.currentHospitalDoctorsSearchData) {
            this.setState({
                specialty: nextProps.currentHospitalDoctorsSearchData.specialty,
                branch: nextProps.currentHospitalDoctorsSearchData.branch,

            }, () => {
                console.log(this.state.specialty);
            });
        }
    }
    handleBranchOnChange = (selectedOption) => {
        this.setState({branch: selectedOption.value});
    };
    handleSpecialtyOnChange = (selectedOption) => {
        this.setState({specialty: selectedOption.value});
    };
    /********MOBILE***********/
    handleBranchOnChangeMobile = (e) => {
        this.setState({branch: JSON.parse(e.target.value)});
    };
    handleSpecialtyOnChangeMobile = (e) => {
        this.setState({specialty: JSON.parse(e.target.value)});
    };

    handleSetCurrentHospitalDoctorsSearchData = (data = this.state) => {
        this.props.setHospitalDoctorsSearchData(data);
        localStorage.setItem("hospitalDoctorsSearchData", JSON.stringify(data));
        this.props.clearHospitalDoctorsList();
        const branch = this.state.branch && this.state.branch !== {} ? this.state.branch.id : -1;
        const specialty = this.state.specialty && this.state.specialty !== {} ? this.state.specialty.id : -1;
        this.props.getHospitalDoctors(this.props.hospital.profile.unique_id, branch, specialty)
    };


    clearSearchKey = async (key) => {
        let state = {
            ...this.state
        };
        switch (key) {
            case "branch":
                state = {...state, branch: null};
                break;

            case "specialty":
                state = {...state, specialty: null};
                break;
            default:
            //
        }

        await this.setState({
            ...state
        }, () => {
            this.props.clearHospitalDoctorsSearchData();
        });
    };

    render() {
        let branches = [];
        let branchesMobile = [];
        if (this.props.hospital && this.props.hospital.branches && this.props.hospital.branches.length) {
            this.props.hospital.branches.forEach((branch) => {
                if (!this.props.mobileMenuIsShown) {
                    branches = [...branches, {
                        value: branch,
                        label: branch.name
                    }]
                } else {
                    branchesMobile = [...branchesMobile,
                        <option value={JSON.stringify(branch)}>{branch.name}</option>
                    ]
                }
            });
        }


        let specialities = [];
        let specialitiesMobile = [];
        if (this.props.hospital && this.props.hospital.specialities && this.props.hospital.specialities.length) {
            this.props.hospital.specialities.forEach((specialty) => {
                if (!this.props.mobileMenuIsShown) {
                    specialities = [...specialities, {
                        value: specialty,
                        label: specialty.name
                    }]
                } else {
                    specialitiesMobile = [...specialitiesMobile,
                        <option value={JSON.stringify(specialty)}>{specialty.name}</option>
                    ]
                }
            });
        }


        // let branchLabel = this.props.currentHospitalDoctorsSearchData && this.props.currentHospitalDoctorsSearchData.branch ? this.props.currentHospitalDoctorsSearchData.branch.name : "branch ...";
        return (
            <section className="main-search ">

                <div className="container">
                    <div className="row ">
                        <div className="shadow-4d col-md-8 offset-2 no-padding">
                            <div className="row full-width search-box-with-shadow">
                                <div
                                    className={this.props.mobileMenuIsShown ? "col-md-4 full-height no-padding border-bottom" : "col-md-4 full-height no-padding"}>
                                    {!this.props.mobileMenuIsShown ?
                                        <div className="form-group full-height border-right">
                                            <div className="full-height">
                                                <i className="fas fa-building search-icon"></i>
                                                <Select
                                                    className={this.state.branch ? "currentSearchData full-height capitalized" : "full-height capitalized"}
                                                    placeholder={this.state.branch ? this.state.branch.name : this.props.translate("branch") + "..."}
                                                    onChange={this.handleBranchOnChange}
                                                    options={branches}
                                                    value={this.state.branch ? this.state.branch.name : null}
                                                />
                                            </div>
                                        </div> :
                                        <select id="branch"
                                                className="mobile-select custom-select capitalized"
                                                onChange={this.handleBranchOnChangeMobile}
                                        >
                                            <option value="" disabled
                                                    selected>{this.props.translate("branch") + "..."}</option>
                                            {branchesMobile}
                                        </select>
                                    }

                                </div>
                                <div
                                    className={this.props.mobileMenuIsShown ? "col-md-4 full-height no-padding border-bottom" : "col-md-4 full-height no-padding"}>
                                    {!this.props.mobileMenuIsShown ?
                                        <div className="form-group full-height border-right">
                                            <div className="full-height">
                                                <i className="fa fa-stethoscope search-icon"></i>
                                                <Select
                                                    className={this.state.specialty ? "currentSearchData full-height capitalized" : "full-height capitalized"}
                                                    placeholder={this.state.specialty ? this.state.specialty.name : this.props.translate("specialty") + "..."}
                                                    onChange={this.handleSpecialtyOnChange}
                                                    options={specialities}
                                                    value={this.state.specialty ? this.state.specialty.name : null}
                                                />
                                            </div>

                                        </div>
                                        : <select
                                            className="mobile-select custom-select capitalized"
                                            onChange={this.handleSpecialtyOnChangeMobile}
                                        >
                                            <option value="" disabled
                                                    selected>{this.props.translate("specialty") + "..."}</option>
                                            {specialitiesMobile}
                                        </select>}
                                </div>
                                <div className="col-md-4 full-height no-padding">
                                    <button onClick={() => this.handleSetCurrentHospitalDoctorsSearchData()}
                                            className="btn btn-block full-height">
                                        <span className="font-20  m-r-5">{this.props.translate('search')}</span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="row mt-20">
                        <div className="col-md-8 offset-2">
                            <div className="search-key">
                                <span className="block shadow-4d search-key-span"
                                      hidden={!this.state.branch}>
                                {this.state.branch ? this.state.branch.name : ""}
                                    <i className="fas fa-times pull-right"
                                       onClick={() => this.clearSearchKey("branch")}></i>
                                </span>

                                <span className="block shadow-4d search-key-span"
                                      hidden={!this.state.specialty}>
                                {this.state.specialty ? this.state.specialty.name : ""}
                                    <i className="fas fa-times pull-right"
                                       onClick={() => this.clearSearchKey("specialty")}></i>
                                </span>
                            </div>
                        </div>
                    </div>

                </div>
            </section>
        )
    }
}


const mapStateToProps = (state) => {
    return {
        currentHospitalDoctorsSearchData: state.hospital.currentHospitalDoctorsSearchData
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        setHospitalDoctorsSearchData: (data) => dispatch(setHospitalDoctorsSearchData(data)),
        clearHospitalDoctorsSearchData: () => dispatch(clearHospitalDoctorsSearchData()),
        getHospitalDoctors: (hospital_id, speciality_id, branch_id) => dispatch(getHospitalDoctors(hospital_id, speciality_id, branch_id)),
        clearHospitalDoctorsList: () => dispatch(clearHospitalDoctorsList()),
    }
};


export default connect(mapStateToProps, mapDispatchToProps)(globalMiddleware(withTranslate(withRouter(withLastLocation(HospitalDoctorsSearch)))))


/// References ////////
//// https://www.npmjs.com/package/izitoast/v/1.0.2




